// WAF规则集定义
import React from 'react';
import { SafetyOutlined, FileProtectOutlined, ApiOutlined, ScanOutlined, RobotOutlined, BlockOutlined, FileSearchOutlined, GlobalOutlined } from '@ant-design/icons';
// 这些规则集用于防火墙配置和页面规则中的WAF action

export const WAF_RULESETS = {
  sqli: {
    name: 'SQL injection protection',
    description: 'Blocks SQL injection attacks',
    category: 'injection',
    enabled: true,
    severity: 'high',
    rules: ['detect-sqli']
  },
  xss: {
    name: 'XSS protection',
    description: 'Blocks cross-site scripting (XSS) attacks',
    category: 'injection',
    enabled: true,
    severity: 'high',
    rules: ['detect-xss']
  },
  path_traversal: {
    name: 'Path traversal protection',
    description: 'Prevents directory traversal and file inclusion attacks',
    category: 'file',
    enabled: false,
    severity: 'high',
    rules: ['path-traversal']
  },
  command_injection: {
    name: 'Command injection protection',
    description: 'Prevents OS command injection',
    category: 'injection',
    enabled: false,
    severity: 'high',
    rules: ['command-injection']
  },
  lfi_rfi: {
    name: 'File inclusion protection',
    description: 'Prevents local/remote file inclusion attacks',
    category: 'file',
    enabled: false,
    severity: 'medium',
    rules: ['lfi', 'rfi']
  },
  protocol_attack: {
    name: 'Protocol attack protection',
    description: 'Prevents HTTP protocol violations and malformed requests',
    category: 'protocol',
    enabled: false,
    severity: 'medium',
    rules: ['protocol-violations']
  },
  scanner_detection: {
    name: 'Scanner detection',
    description: 'Identifies and blocks automated scanning tools',
    category: 'scanner',
    enabled: false,
    severity: 'low',
    rules: ['scanner-detection']
  },
  bad_robots: {
    name: 'Bad bot protection',
    description: 'Blocks known malicious crawlers and bots',
    category: 'bot',
    enabled: false,
    severity: 'low',
    rules: ['bad-robots']
  },
  rulesets_additional: {
    name: 'Additional protection: web shells/backdoors, deserialization',
    description: 'Blocks web shell/backdoor access and Java/PHP deserialization attacks (OWASP CRS)',
    category: 'additional',
    enabled: true,
    severity: 'high',
    rules: ['owasp-crs-webshell', 'owasp-crs-deserialization']
  }
};

// 获取规则集选项列表（用于下拉框）
export const getWafRulesetOptions = () => {
  return Object.entries(WAF_RULESETS).map(([key, ruleset]) => ({
    value: key,
    label: ruleset.name,
    description: ruleset.description,
    severity: ruleset.severity,
    category: ruleset.category
  }));
};

// 按类别分组规则集
export const groupRulesetsByCategory = () => {
  const grouped = {};
  Object.entries(WAF_RULESETS).forEach(([key, ruleset]) => {
    if (!grouped[ruleset.category]) {
      grouped[ruleset.category] = [];
    }
    grouped[ruleset.category].push({ key, ...ruleset });
  });
  return grouped;
};

// 类别名称映射
export const CATEGORY_NAMES = {
  injection: 'Injection protection',
  file: 'File security',
  protocol: 'Protocol security',
  scanner: 'Scanner protection',
  bot: 'Bot protection',
  bots: 'Scanners & bots',
  response: 'Response inspection',
  additional: 'Additional protection',
  cms: 'WordPress'
};

// 类别图标映射（antd 图标，与控制台其他地方一致）
export const CATEGORY_ICONS = {
  injection: React.createElement(SafetyOutlined),
  file: React.createElement(FileProtectOutlined),
  protocol: React.createElement(ApiOutlined),
  scanner: React.createElement(ScanOutlined),
  bot: React.createElement(RobotOutlined),
  bots: React.createElement(RobotOutlined),
  response: React.createElement(FileSearchOutlined),
  additional: React.createElement(BlockOutlined),
  cms: React.createElement(GlobalOutlined)
};

// 严重程度颜色映射
export const SEVERITY_COLORS = {
  high: 'red',
  medium: 'orange',
  low: 'blue'
};

// 严重程度名称映射
export const SEVERITY_NAMES = {
  high: 'High risk',
  medium: 'Medium risk',
  low: 'Low risk'
};
